import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import {
  ActionSheetController,
  AlertController,
  Events,
  ModalController,
  NavController, NavParams, PopoverController,
  Refresher,
  ViewController
} from 'ionic-angular';
import { StaffCurrentQueueComponent } from "../../components/staff-current-queue/staff-current-queue";
import { StaffAdvancedBookingsComponent } from "../../components/staff-advanced-bookings/staff-advanced-bookings";
import { StaffCompletedBookingsComponent } from "../../components/staff-completed-bookings/staff-completed-bookings";
import { ServicesPage } from "../services/services";
import { HttpClient } from "@angular/common/http";
import { ApiErrorHandlerProvider } from "../../providers/api-error-handler/api-error-handler";
import { TimezoneProvider } from "../../providers/timezone/timezone";
import { AdvancedBookingsPage } from "../advanced-bookings/advanced-bookings";
import { TabsServiceProvider } from "../../providers/tabs-service/tabs-service";
import { RegisterGuestServiceProvider } from "../../providers/register-guest-service/register-guest-service";
import { CheckinPopoverPage } from "../checkin-popover/checkin-popover";
import { StaffServiceProvider } from "../../providers/staff-service/staff-service";
import { BookingServiceProvider } from "../../providers/booking-service/booking-service";
import { CalendarMode, Step } from 'ionic2-calendar/calendar';
import * as moment from 'moment-timezone';
import { CustomBookinCardComponent } from '../../components/custom-bookin-card/custom-bookin-card';
import { getCurrencySymbol } from '@angular/common';
import { CalendarComponent } from 'ion2-calendar';
import { BookingDetails } from '../booking-details/booking-details';
import { DurationPipe } from '../../pipes/duration/duration';
import { CompleteBookingModalPage } from '../complete-booking-modal/complete-booking-modal';

@Component({
  selector: 'page-my-chair',
  templateUrl: 'my-chair.html',
})
export class MyChairPage {
  eventSource;
  viewTitle;

  CurrentDay: any;
  startWeek: any;
  EndWeek: any;


  currentMonth: any;
  selectedMonthEvents: any[] = [];

  isToday: boolean;
  calendar = {
    mode: 'day' as CalendarMode,
    step: 30 as Step,
    currentDate: new Date(),
    dateFormatter: {
      formatMonthViewDay: function (date: Date) {
        return date.getDate().toString();
      },
      formatMonthViewDayHeader: function (date: Date) {
        return 'MonMH';
      },
      formatMonthViewTitle: function (date: Date) {
        return 'testMT';
      },
      formatWeekViewDayHeader: function (date: Date) {
        return 'MonWH';
      },
      formatWeekViewTitle: function (date: Date) {
        return 'testWT';
      },
      formatWeekViewHourColumn: function (date: Date) {
        return 'testWH';
      },
      formatDayViewHourColumn: function (date: Date) {
        return 'testDH';
      },
      formatDayViewTitle: function (date: Date) {
        return 'testDT';
      }
    }
  };


  errors: {};
  loading: boolean;
  toggleLoading: boolean = false;
  staffId: any;
  barber: any;
  tuid: string;
  teamId: string;
  checkInToggle: boolean;
  currentTeam: any;
  selectedTeam: any;
  staffHasMultipleShops: any;

  queue: StaffCurrentQueueComponent;
  advanced: StaffAdvancedBookingsComponent;
  completed: StaffCompletedBookingsComponent;
  hideTabs: boolean = false;
  tabs: any = "day";
  currencySymbol: string;

  @ViewChild(Refresher) refresher: Refresher;
  @ViewChild('calendar') MyCalendar: CalendarComponent;
  bookings:any;
  upcomingBookings: Array<any>;
  completedBookings: any = [];
  currentOrNextBooking: any;
  private bookingDetailsPopover: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public tz: TimezoneProvider,
    private viewCtrl: ViewController,
    private http: HttpClient,
    private actionSheetCtrl: ActionSheetController,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private tabsService: TabsServiceProvider,
    private registerGuestService: RegisterGuestServiceProvider,
    private popoverCtrl: PopoverController,
    private staffProvider: StaffServiceProvider,
    public bookingProvider: BookingServiceProvider,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    private cdr: ChangeDetectorRef,
    public durationPipe: DurationPipe,
  ) {
    this.staffId = navParams.get('staffId') ? navParams.get('staffId') : localStorage.getItem('tuid');
    this.teamId = navParams.get('teamId') ? navParams.get('teamId') : localStorage.getItem('currentTeamId');
    this.hideTabs = navParams.get('hideTabs');
    this.staffHasMultipleShops = navParams.get('staffHasMultipleShops');
    events.subscribe('myChair:more-option', () => {
      if (this.bookingDetailsPopover) {
        this.bookingDetailsPopover.dismiss().catch(() => {
          console.warn('Popover already dismissed.');
        });
      }
    });
  }

  ionViewWillEnter() {
    this.tuid = localStorage.getItem('tuid');
    this.tabs = "day";
    this.calendar.mode= "day";

    const now = moment();
    this.CurrentDay = now.format('dddd, D');

    const weekday = moment();
    const startWeek = weekday.startOf('week').toDate();
    const EndWeek = weekday.endOf('week').toDate();

    this.startWeek = moment(startWeek).format('D MMMM');
    this.EndWeek = moment(EndWeek).format('D MMMM');

    this.currentMonth = moment(now).format('MMMM, YYYY');

    if (this.tuid) {
      this.loading = true;
      // this.getBookings().then(() => { });
      this.getBarberWithBookings().then(() => {
        this.setBookings();
        this.tz.timezone(this.teamId).then((currencySymbol: string) => {
          this.currencySymbol = currencySymbol;
          this.loading = false;
        });
      }, (error) => {
        this.loading = false;
      });
    }

    if (!this.hideTabs) {
      this.tabsService.show();
    }
  }

  setBookings() {
    if(this.barber) {
      this.bookings=[];

      if(this.barber && this.barber.todays_bookings && this.barber.todays_bookings.length > 0){
        for (let index = 0; index < this.barber.todays_bookings.length; index++) {
          const element = this.barber.todays_bookings[index].booking;
          this.bookings.push(element); 
        }
      }
      if(this.barber && this.barber.upcoming_advanced_bookings && this.barber.upcoming_advanced_bookings.length > 0){
        for (let index = 0; index < this.barber.upcoming_advanced_bookings.length; index++) {
          const element = this.barber.upcoming_advanced_bookings[index].booking;
          this.bookings.push(element); 
        }
      }

      if (this.bookings.length > 0) {
        this.bookings = this.bookings.filter(res => res.completed_at == null && res.cancelled_at == null);
      }
      this.getCompletedBookings();
      this.loadEvents();
    }
  }

  checkInOutToggle() {
    this.checkInToggle = this.barber.current_active_team == this.teamId ? true : false;
  };
  getBarberWithBookings() {
    return new Promise((resolve, reject) => {
      this.http.get(`/teams/${this.teamId}/bookings/byStaff/${this.staffId}`).subscribe((barber: any) => {
        this.barber = barber;

        // if(barber.teams[0].timezone.timezone) {
        //   const timezoen = new Date(new Date().toLocaleString("en-US", { timeZone: barber.teams[0]?.timezone?.timezone }));
        //   this.calendar.currentDate = timezoen;
        //   const now = moment(timezoen);

        //  this.CurrentDay = now.format('dddd, D');

        //  const weekday = moment();
        //  const startWeek = weekday.startOf('week').toDate();
        //  const EndWeek = weekday.endOf('week').toDate();

        //  this.startWeek = moment(startWeek).format('D MMMM');
        //  this.EndWeek = moment(EndWeek).format('D MMMM');

        //  this.currentMonth = moment(now).format('MMMM, YYYY');

        // }

        this.setCurrentTeam(barber.teams);
        this.setSelectedTeam(barber.teams);
        this.checkInOutToggle();
        return resolve(true);
      }, error => {
        this.errors = this.apiErrorHandler.handleError(error);
        return reject(this.errors);
      })
    })
  }

  getBookings() {

    return new Promise((resolve, reject) => {
      let url = `/bookings/${this.tuid}`;

      if (localStorage.getItem('multiShop') && localStorage.getItem('ownerId')) {
        url += `?owner=${localStorage.getItem('ownerId')}`
      }

      this.http.get(url)
        .subscribe((bookings: any) => {
          this.bookings = bookings;
          if (this.bookings.length > 0) {
            this.getCompletedBookings();
            this.bookings = this.bookings.filter(res => res.completed_at == null && res.cancelled_at == null);
            this.loadEvents();
          }
          return resolve(true);
        }, error => {
          this.errors = this.apiErrorHandler.handleError(error);
          return reject(this.errors);
        }, () => {
          // this.getCompletedBookings();
          // this.getUpcomingBookings().then(() => {
          //     this.events.publish('booking:badge', this.upcomingBookings);

          //     this.getCurrentOrNextBooking().then(() => {
          //     });
          // });
        });

    });

  }

  getCompletedBookings() {
    this.completedBookings = [];
    for (let booking of this.bookings) {
      if (booking.completed_at !== null || booking.cancelled_at !== null) {

        // Handle a cancelled advanced booking date
        if (booking.estimated_booking_date_string === null) {
          booking.estimated_booking_date_string = booking.requested_booking_date_string;
        }

        this.completedBookings.push(booking);
      }
    }

    this.sortCompletedBookings();

  }

  sortCompletedBookings() {
    this.completedBookings.sort((a, b) => a.estimated_booking_time >= b.estimated_booking_time ? -1 : 1);
  }

  loadEvents() {
    var events = [];
    for (var i = 0; i < this.bookings.length; i += 1) {
      let totalDuration: number = 0;
      if (this.bookings[i].services.length > 0) {
        this.bookings[i].services.forEach(service => {
          const {  quantity } = service;
          const duration  = service.service.service.duration;
          const serviceTotalDuration = duration * quantity;
          totalDuration += serviceTotalDuration;
        });
      }

      let startTime = new Date(this.bookings[i].requested_booking_time ? this.bookings[i].requested_booking_time :  this.bookings[i].estimated_booking_time);
      let endTime = new Date(new Date(new Date(this.bookings[i].requested_booking_time ? this.bookings[i].requested_booking_time :  this.bookings[i].estimated_booking_time).setSeconds(0)).getTime() + totalDuration * 60000)

      events.push({
        title: `duration:${totalDuration} | ${this.bookings[i].services[0].name} - ${this.formatTimeAMPM(startTime)}`,
        startTime,
        endTime,
        allDay: false,
        ...this.bookings[i]
      });
    }
    this.eventSource = events;
    setInterval(() => {
      this.colorEvents();
    }, 100);
  }

  colorEvents() {
    const events : any = document.querySelectorAll('.calendar-event-inner');
    if(events){

      events.forEach((el: any) => {
        const text = el.innerText;
    
        if (text.includes('duration:10')) {
          el.style.backgroundColor = '#E1CBA8';
          el.style.color = '#000';
        } else if (text.includes('duration:20')) {
          el.style.backgroundColor = '#000000';
          el.style.color = '#fff';
        }else if(text.includes('duration:30')) {
          el.style.backgroundColor = '#2C2C2C';
          el.style.color = '#fff';
        } else if (text.includes('duration:60')) {
          el.style.backgroundColor = '#F6F0E3';
          el.style.color = '#000';
        }else if (text.includes('duration:120')) {
          el.style.backgroundColor = '#B49F84';
          el.style.color = '#000';
        } else if (text.includes('duration:')) {
          el.style.backgroundColor = '#CAA265';
          el.style.color = '#000';
        }
      });
    }
  }
  

  formatTimeAMPM(date: Date): string {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesFormatted = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${minutesFormatted} ${ampm}`;
  }

  addToQueue() {
    //@todo in /v3/ of the api, return an object and do a check as follows
    //if (this.barber.hasOwnProperty('advanced_booking_hours') && this.barber.advanced_booking_hours)

    if (this.barber.advanced_booking_hours.length > 0) {
      this.presentActionSheet();
    } else {
      this.registerGuestService.register().then(guestUser => {
        this.openPage(ServicesPage, guestUser);
      }).catch(_ => {

      });
    }
  }

  toggleCheckIn(currentTeamId, barberId) {

    let event = this.checkInToggle !== true;

    if (this.selectedTeam) {
      currentTeamId = this.selectedTeam.id;
    }

    if (this.barber.teams.length === 1 || this.barber.current_active_team === this.teamId || this.barber.current_active_team === null) {
      this.toggleLoading = true;
      this.staffProvider.toggleCheckIn(event, currentTeamId, barberId).then((res) => {
        this.getBarberWithBookings().then(() => {
          this.setBookings();
          this.toggleLoading = false;
          if (this.barber.current_active_team) {
            localStorage.setItem('currentTeamId', this.barber.current_active_team);
          }
        })
      }).catch(error => {
        this.toggleLoading = false;
      });
      return;
    }

    this.checkinPopover();
  }

  checkinPopover() {
    let checkinPopover = this.popoverCtrl.create(CheckinPopoverPage,
      {
        currentTeam: this.currentTeam,
        selectedTeam: this.selectedTeam,
        barber: this.barber
      },
      {
        cssClass: 'complete-booking-modal',
        enableBackdropDismiss: false
      });

    checkinPopover.present();

    checkinPopover.onDidDismiss((team) => {
      if (team) {
        this.loading = true;
        this.staffProvider.toggleCheckIn(true, team.id, this.barber.id).then((res) => {
          this.getBarberWithBookings().then(() => {
            this.setBookings();
            if (this.barber.current_active_team) {
              localStorage.setItem('currentTeamId', this.barber.current_active_team);
            }
            this.loading = false;
          })
        }).catch(error => {
          this.loading = false;
        });
      }
    })
  }

  pullToRefresh() {
    const now = moment();
    this.CurrentDay = now.format('dddd, D');

    const weekday = moment();
    const startWeek = weekday.startOf('week').toDate();
    const EndWeek = weekday.endOf('week').toDate();

    this.startWeek = moment(startWeek).format('D MMMM');
    this.EndWeek = moment(EndWeek).format('D MMMM');

    this.currentMonth = moment(now).format('MMMM, YYYY');
    this.calendar.currentDate = new Date();

    this.getBarberWithBookings().then(() => {
      this.setBookings();
      this.refresher.complete();
    }).catch(() => {
      this.refresher.complete();
    });
  }

  presentActionSheet() {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Choose your booking type',
      buttons: [
        {
          text: 'Standard Booking',
          handler: () => {
            actionSheet.dismiss().then(_ => {
              this.registerGuestService.register().then(guestUser => {
                this.openPage(ServicesPage, guestUser);
              }).catch(_ => {

              });
            });
            return false;
          }
        },
        {
          text: 'Advanced Booking',
          handler: () => {
            actionSheet.dismiss().then(_ => {
              this.registerGuestService.register().then(guestUser => {
                this.openPage(AdvancedBookingsPage, guestUser);
              }).catch(_ => {

              });
            });
            return false;
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });
    actionSheet.present();
  }

  setCurrentTeam(teams) {
    teams.forEach((team) => {
      if (team.id === this.barber.current_active_team) {
        this.currentTeam = team;
      }
    })
  }

  setSelectedTeam(teams) {
    teams.forEach((team) => {
      if (Number(team.id) === Number(this.teamId)) {
        this.selectedTeam = team;
      }
    })
  }

  openPage(page, guestUser) {
    return this.getShop(this.teamId).then((shop) => {
      return this.navCtrl.push(page, {
        barber: this.barber,
        shop: shop,
        services: this.barber.services,
        byStaff: true,
        allowDateSelection: false,
        guestUser: guestUser
      })
    })
  }

  getShop(id) {
    this.loading = true;

    return new Promise((resolve, reject) => {
      this.http.get(`/teams/${id}`)
        .subscribe((shop: any) => {
          return resolve(shop);
        }, error => {
          this.errors = this.apiErrorHandler.handleError(error);
          return reject();
        }, () => {
          this.loading = false;
        });
    });
  }

  changeMode() {
    this.calendar.currentDate = new Date();
    this.calendar.mode = this.tabs;
    if (this.calendar.mode == 'week') {
      setTimeout(() => {
        const elements = document.querySelectorAll('.weekview-header.text-center');
        if(elements.length > 0){
          Array.from(elements).forEach(element => {
          const text = element.textContent.trim();
          if (text.split(' ').length > 1) {
            const [dayName, dayNumber] = text.split(' ');
            element.innerHTML = `${dayName}<br><span>${dayNumber}</span>`;
          }
        });
      }
      }, 10);
    }
  }

  onCurrentDateChanged(event: Date) {
    switch (this.calendar.mode) {
      case 'day':
        this.setCurrentDay(event);
        break;
      case 'week':
        this.getViewRange(event);
        break;
      case 'month':
        this.getViewRange(event);
        break;
      default:
        break;
    }

  }

  setCurrentDay(event) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    event.setHours(0, 0, 0, 0);
    this.isToday = today.getTime() === event.getTime();
    this.CurrentDay = moment(event).format('dddd, D');
  }

  getViewRange(date: Date) {
    const momentDate = moment(date);
    if (this.calendar.mode === 'week') {
      const start = momentDate.startOf('week').toDate();
      const end = momentDate.endOf('week').toDate();
      this.startWeek = moment(start).format('D MMMM');
      this.EndWeek = moment(end).format('D MMMM');
    } else if (this.calendar.mode === 'month') {
      this.currentMonth = moment(momentDate).format('MMMM, YYYY');
    }

    if (this.calendar.mode == 'week') {
      setTimeout(() => {
        const elements = document.querySelectorAll('.weekview-header.text-center');
        if(elements.length > 0){
          Array.from(elements).forEach(element => {
            const text = element.textContent.trim();
            if (text.split(' ').length > 1) {
              const [dayName, dayNumber] = text.split(' ');
              element.innerHTML = `${dayName}<br><span>${dayNumber}</span>`;
            }
          });
      }
      }, 10);
    }
  }


  onEventSelected(event) {
    this.openBookingDetails(event);
  }
  openBookingDetails(booking) {
    this.bookingDetailsPopover = this.popoverCtrl.create(
      BookingDetails, // Replace with your booking details component
      {
        booking: booking, // Pass the booking object to the modal
        barber: this.barber,
        currencySymbol: this.currencySymbol,
      },
      {
        cssClass: 'booking-details-modal',
        enableBackdropDismiss: true,
      }
    );

    this.bookingDetailsPopover.present();

    this.bookingDetailsPopover.onDidDismiss((data) => {
      this.refreshBookings(); // Call a method to refresh bookings if needed
    });
  }
  refreshBookings() {
    console.log("Refreshing bookings");
    
    // Add logic to refresh the bookings, e.g., fetch updated data from the server
    this.loading = true;
    this.getBarberWithBookings().then(() => {
      this.setBookings();
      this.loading = false;
    });
  }

  showAlert(booking) {

    let alert = this.alertCtrl.create({
      // title: ``,
      cssClass: 'custom-profile-alert',
      message: `
            <section class="bookings__upcoming " style="padding: 10px;background: #FFFFFF;">
        <ng-container>
          <ion-card [class.opacity-10]="opacity">
            <div class="card-booking booking flex flex-column">
              <div class="booking__date-time flex flex-space-between margin-bottom-1">
                <div text-uppercase>${booking.user.name}</div>
                <div text-uppercase>
                   <div class="flex item-center gap-6"> <img width="12" height="12" src="${this.getTimeUrl()}" /> 
                   ${booking.requested_booking_time ?
          booking.requested_booking_time_string : booking.estimated_booking_time_string}
                   </div>
                </div>
              </div>
              <div class="booking__time flex flex-space-between margin-bottom-1">
                  <div class="flex item-center gap-10"> <img width="12" height="12" src="${this.getTimeUrl()}" /> Time</div>
                  <div>${booking.services[0].service.service.duration * booking.services[0].quantity} minutes</div>
              </div>  

              <div class="margin-top-0">
                <ng-container>
                    <hr class="margin-top-1 margin-bottom-2 custom-hr">
                    <div class="flex flex-column line-height-lg">
                          <div class="flex flex-space-between">
                            <div class="flex">
                              <div class="service_name position-relative">${booking.services[0].name}</div>
                            </div>
                            <div class="color-black font-weight-bold">${this.currencySymbol}${booking.services[0].price * booking.services[0].quantity}</div>
                          </div>
                    </div>

                    <hr class="margin-top-1 margin-bottom-2 custom-hr">
                    <div class="flex flex-space-between line-height-lg">
                      <div class="total-label">Total Paid</div>
                      <div class="color-black font-weight-bold font-size-lg">
                      ${this.currencySymbol}${this.amountPaid(booking)}</div>
                    </div>
                    <div class="flex flex-space-between line-height-lg">
                      <div class="total-label">Total Due</div>
                      <div class="color-black font-weight-bold font-size-lg">
                     ${this.currencySymbol}${this.amountDue(booking)}</div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ion-card>
          </ng-container>
      </section>
      `,
      // enableBackdropDismiss: false,
      mode: 'ios',
      buttons: []
    });
    alert.present();
  }

  getTimeUrl() {
    return 'assets/icon/history_clock.svg'
  }

  onViewTitleChanged(title) {
    this.viewTitle = title;
  }

  amountPaid(booking) {
    return this.bookingProvider.getAmountPaid(booking);
  }

  amountDue(booking) {
    return this.bookingProvider.getAmountDue(booking);
  }

  onTimeSelected(ev) {
    this.selectedMonthEvents = [];
    if (this.calendar.mode == 'month') {
      this.selectedMonthEvents = ev.events;
    }
  }

  moveToNext() {
    if (this.calendar && this.calendar.mode == 'month') {
      const currentDate = this.calendar.currentDate;
      const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
      this.calendar.currentDate = new Date(nextMonth);
      this.cdr.detectChanges();
    }
    else if (this.calendar && this.calendar.mode == 'week') {
      const currentDate = this.calendar.currentDate;
      const nextWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 7);
      this.calendar.currentDate = nextWeek;
      this.cdr.detectChanges();
    }
    else if (this.calendar && this.calendar.mode == 'day') {
      const currentDate = this.calendar.currentDate;
      const nextDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1);
      this.calendar.currentDate = nextDay;
      this.cdr.detectChanges();
    }
  }

  moveToPrevious() {
    if (this.calendar && this.calendar.mode == 'month') {
      const currentDate = this.calendar.currentDate;
      const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
      this.calendar.currentDate = new Date(nextMonth);
      this.cdr.detectChanges();
    }
    else if (this.calendar && this.calendar.mode == 'week') {
      const currentDate = this.calendar.currentDate;
      const nextWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 7);
      this.calendar.currentDate = nextWeek;
      this.cdr.detectChanges();
    }
    else if (this.calendar && this.calendar.mode == 'day') {
      const currentDate = this.calendar.currentDate;
      const nextDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 1);
      this.calendar.currentDate = nextDay;
      this.cdr.detectChanges();
    }
  }
  confirmBookingCompletion(booking) {
      let bookingCompletionModal = this.popoverCtrl.create(CompleteBookingModalPage,
          {
              booking: booking,
              barber: this.barber
          },
          {
              cssClass: 'complete-booking-modal',
              enableBackdropDismiss: false
          });

      bookingCompletionModal.present();

      // Add the completed booking to the completed bookings array
      bookingCompletionModal.onDidDismiss((res) => {
          if (res && (res.id === booking.id)) {
              this.barber.todays_completed_bookings.push(booking);
              this.barber.todays_bookings.splice(0, 1);

              this.events.publish('myChair:badge');
          }
      })
  }
}


// WEBPACK FOOTER //
// ./src/pages/my-chair/my-chair.ts